import {ComparatorBase, ComparisonTypeEnum} from "./ComparatorBase";
import * as React from "react";
import DatePicker from "react-datepicker";
import './DateComparator.css';
import * as ReactDOM from "react-dom";
import 'react-datepicker/dist/react-datepicker.css';
import {DateUtilities} from "shared/utilities/DateUtilities";


export class DateTimeComparator extends ComparatorBase{



    public GetComparator(skipValueLessConditions=false){
        return (
            <select className={this.GetComparisonClass()} value={this.Condition.ConditionLineOptions.Comparison} onChange={x=>this.ComparisonChanged(x.target.value.toString())} style={{height:'auto',padding:0,width:'100%'}} >
                <option value={ComparisonTypeEnum.Equal}>Equal to</option>
                <option value={ComparisonTypeEnum.NotEqual}>Not Equal to</option>
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsEmpty}>Is Empty</option>}
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsNotEmpty}>Is Not Empty</option>}
                <option value={ComparisonTypeEnum.GreaterThan}>Greater Than</option>
                <option value={ComparisonTypeEnum.GreaterOrEqualThan}>Greater or Equal Than</option>
                <option value={ComparisonTypeEnum.LessThan}>Less Than</option>
                <option value={ComparisonTypeEnum.LessOrEqualThan}>Less or Equal Than</option>
            </select>
        );
    }

    InitializeValues() {
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum.Equal;
    }

    public GetValueInput(){
        let comparisonType=this.Condition.props.ConditionLineOptions.Comparison;

        return <DatePicker
            className={'condition-datepicker '+this.GetValueClass()}
            showTimeSelect={true}
            selected={DateUtilities.UnixToDate(this.Condition.props.ConditionLineOptions.Value)}
            onChange={x=>this.ValueChanged(x)}
            dateFormat="dd/MMM/yyyy h:mm aa"
            style={{minWidth:150,width:'100%',height:25,padding:'5px 6px'}} type={'text'}
            disabled={comparisonType==ComparisonTypeEnum.IsEmpty||comparisonType==ComparisonTypeEnum.IsNotEmpty}
            popperContainer={this.GetContainer}

        />
    }



    private ComparisonChanged(s: string) {
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum[s];
        this.Condition.forceUpdate();
    }

    private ValueChanged(value: Date) {
        this.Condition.ConditionLineOptions.Value=DateUtilities.DateToUnix(value);
        this.Condition.forceUpdate();
    }

    private GetContainer(children:any)
    {

        const el = document.getElementsByTagName('body') as any;
        return ReactDOM.createPortal(children.children,el[0]);


    }
}